var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoxFlat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4447 1.66663H16.9448C17.7118 1.66663 18.3337 2.28845 18.3337 3.05551V16.9444C18.3337 17.7115 17.7118 18.3333 16.9448 18.3333H3.05588C2.28882 18.3333 1.66699 17.7115 1.66699 16.9444V3.05551C1.66699 2.28845 2.28882 1.66663 3.05588 1.66663H7.52806H7.54658V8.787C7.54658 8.90737 7.6114 9.00922 7.71325 9.05551C7.75028 9.07403 7.77806 9.07403 7.8151 9.07403C7.88917 9.07403 7.95399 9.04626 8.00954 8.9907L8.87066 7.92589L9.80584 8.99996C9.91695 9.11107 10.0836 9.10181 10.1855 8.99996L11.1021 7.93514L11.9818 8.99996C12.0558 9.08329 12.1762 9.11107 12.2781 9.06477C12.3799 9.01848 12.4447 8.91663 12.4447 8.79626V1.66663Z",
    fill: "#769DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxFlat);
export default __webpack_public_path__ + "static/media/icon_box_flat.65d033a5f4821aada9a06605a5b631b9.svg";
export { ForwardRef as ReactComponent };